module.exports = __webpack_public_path__ + "static/media/measurements_icon.93712ebd.svg";